import { z } from 'zod';

export const getRoleMWModulesSchema = z.array(
  z.object({
    id: z.string(),
    roleID: z.string(),
    mwModuleID: z.string(),
    mwApplicationID: z.string(),
    isBinaryAllowed: z.boolean(),
    isMobileAllowed: z.boolean(),
    isFromManager: z.boolean(),
    isActive: z.boolean(),
  })
);

export type GetRoleMWModulesResponse = z.infer<typeof getRoleMWModulesSchema>;
